
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';

import RollHistoryModal from '../RollHistoryModal';
import { AngleDown, Star, AngleRight, Circle,AccessTime, Trash, Edit} from "theme/icon";
import { collectFormValues } from 'validate.js';
import "./styles.css";
import { connect, ReactReduxContext } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import { Link as RouterLink } from "react-router-dom";
import ReferenceModal from '../ReferenceModal';

import { Translate, I18n } from "react-redux-i18n";
import { confirmDelete } from 'utils/confirmDialog';
import { getPortfolioRowClassName, toggleRowSelected } from 'utils/tableRowSelect';
import { getDisplayDte, getExpiryClassName } from 'utils/optionExpiry';
import { buildOptionDeleteParams } from 'utils/optionGroup';
import {
    getOptionLastPrice,
    getOrderOptionPl,
    getOrderOptionPlPercent,
    formatPl,
} from 'utils/optionPl';
import GraphicModal from '../GraphicModal';
import ActionBtnRight from '../ActionBtnRight';


const stylesLocal = {
    subcell: {
        padding: "5px",
        //fontWeight: "bold",
        //color: "black"
    },
    cell: {
        padding: "5px",
        // fontWeight: "bold",
        //    color: "black"
    }
};

const SubRow = props => {
    const { className, subOrder, order, ...rest } = props;

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(false);
    const [selectedNestedId, setSelectedNestedId] = useState(null);
    const nestedOrders = Array.isArray(subOrder.sub_order) ? subOrder.sub_order : [];
    const isExpandable = Number(subOrder.counter) > 1 || nestedOrders.length > 1;

    const toNum = (value) => Number(value) || 0;

    const breakEven = (item) => {
        if (!item.market || item.counter !== 1) {
            return '';
        }
        const strike = toNum(item.strike);
        const openPrice = Math.abs(toNum(item.open_price));
        if (item.market === 'SELL') {
            return (strike - openPrice).toFixed(2);
        }
        return (strike + openPrice).toFixed(2);
    };

    // const [reference, setReference] = useState("");

    const onClickDelete = (item) => {
        confirmDelete(I18n.t('delete_confirm_message'), () => {
            props.removeItem(props.token, buildOptionDeleteParams(item, props.user_id));
        });
    };

    const getPriceOption = (item) => getOptionLastPrice(item, props.option);

    const renderPl = (pl) => {
        const text = formatPl(pl);
        if (text == null) {
            return null;
        }
        return (
            <span style={{ color: pl < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                {text}
            </span>
        );
    };

    const renderPlPercent = (pct) => {
        const text = formatPl(pct);
        if (text == null) {
            return null;
        }
        return (
            <span style={{ color: pct < 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                {text}%
            </span>
        );
    };

    const subPl = getOrderOptionPl(subOrder, props.option);
    const subPlPercent = getOrderOptionPlPercent(subOrder, props.option);
    const subLast = Number(subOrder.counter) === 1 ? getPriceOption(subOrder) : null;

    return (
        <React.Fragment>
            <tr
                hover
                key={props.key}
                selected={true}
                className={getPortfolioRowClassName(selected)}
                onClick={(event) => toggleRowSelected(event, setSelected)}
            >
                <td align="center">
                    {
                        isExpandable ? (<span
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation();
                                setOpen((prev) => !prev);
                            }}
                        >
                            {open ? <AngleDown /> : <AngleRight />}
                        </span>

                        ) : (<span size="small">
                            <Circle />
                         </span>)
                    }
                </td>
                <td ></td>
                <td  style={stylesLocal.subcell} align="right">
                    {subOrder.open_at && moment(subOrder.open_at).zone("+00:00").format('DD/MM/YYYY')}
                </td>
                <td style={stylesLocal.subcell} align="right">{isExpandable ? subOrder.quantity : ((subOrder.market === "SELL" ? "-" : "+") + subOrder.quantity + (subOrder.option_kind === "CALL" ? "C" : "P"))}</td>
                <td style={stylesLocal.subcell} align="right">  {subOrder.counter === 1 && toNum(subOrder.strike).toFixed(2)} </td>
                <td style={stylesLocal.subcell} align="right">  {toNum(subOrder.open_price).toFixed(2)} </td>
                <td style={stylesLocal.subcell} align="right">
                    {toNum(subOrder.open_trade).toFixed(2)}
                </td>
                <td style={stylesLocal.subcell} align="right">{breakEven(subOrder)}</td>
                <td
                    className={getExpiryClassName(subOrder.expire_at)}
                    style={{ padding: '5px' }}
                >
                    {subOrder.expire_at && moment(subOrder.expire_at).zone("+00:00").format('DD/MM/YYYY')}
                </td>
                <td
                    className={getExpiryClassName(subOrder.expire_at)}
                    style={stylesLocal.subcell}
                    align="right"
                >{subOrder.expire_at && `${getDisplayDte(subOrder.expire_at)}d`}</td>

                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right">
                    {subLast != null && (
                        <React.Fragment>
                            {subLast}
                            <span className="tooltip">
                                <AccessTime fontSize="small" aria-hidden="true" />
                                <span className="tooltiptext">Price delay 15min</span>
                            </span>
                        </React.Fragment>
                    )}
                </td>
                <td style={stylesLocal.cell} align="right">
                    {renderPl(subPl)}
                </td>
                <td style={stylesLocal.subcell} align="right">
                    {renderPlPercent(subPlPercent)}
                </td>
                <td style={stylesLocal.subcell} className="cell_edit">
                    <ReferenceModal
                        key={props.key}
                        item={subOrder}
                    />
                    <span variant="inherit" noWrap>
                        {subOrder.reference}
                    </span>
                </td>
                <td style={stylesLocal.cell} align="right">
                    {
                        subOrder.counter === 1 ? (
                            subOrder.roll_accum && (
                                <RollHistoryModal
                                    item={subOrder}
                                    key={props.key}
                                    color={subOrder.roll_accum < 0 ? "red" : "green"}
                                />
                            )
                        ) :
                            (
                                subOrder.roll_accum && (
                                    <span style={{
                                        "padding": "5px",
                                        "color": subOrder.roll_accum < 0 ? "red" : "green"
                                    }} >
                                        {subOrder.roll_accum}
                                    </span>
                                )
                            )
                    }
                </td>
                <td style={stylesLocal.subcell}>
                    <ActionBtnRight
                        item={subOrder}
                        price={getPriceOption(subOrder)}
                        key={props.key}
                        delete={() => { onClickDelete(subOrder) }}
                    />
                </td>
            </tr>
            <>
                {
                    open && nestedOrders.map((element, index) => {
                        const nestedKey = element.id || `${subOrder.id}-${index}`;
                        return (
                        <tr
                            hover
                            key={nestedKey}
                            className={getPortfolioRowClassName(selectedNestedId === nestedKey)}
                            onClick={(event) => {
                                if (event.target.closest('a, button, input, select, textarea, label, [role="button"], .cell_edit')) {
                                    return;
                                }
                                setSelectedNestedId((prev) => (prev === nestedKey ? null : nestedKey));
                            }}
                        >
                            <td style={stylesLocal.subcell}></td>
                            <td style={stylesLocal.subcell}></td>
                            <td style={stylesLocal.subcell}></td>
                            <td style={stylesLocal.subcell} align="right">{((element.market === "SELL" ? "-" : "+") + element.quantity + (element.option_kind === "CALL" ? "C" : "P"))}</td>
                            <td style={stylesLocal.subcell} align="right">  {toNum(element.strike).toFixed(2)} </td>
                            <td style={stylesLocal.subcell} align="right">  {toNum(element.open_price).toFixed(2)} </td>
                            <td style={stylesLocal.subcell} align="right">
                                {toNum(element.open_trade).toFixed(2)}
                            </td>
                            <td style={stylesLocal.subcell} align="right">{breakEven(element)}</td>
                            <td
                                className={getExpiryClassName(element.expire_at)}
                                style={{ padding: '5px' }}
                            >
                                {element.expire_at && moment(element.expire_at).zone("+00:00").format('DD/MM/YYYY')}
                            </td>
                            <td
                                className={getExpiryClassName(element.expire_at)}
                                style={stylesLocal.subcell}
                                align="right"
                            >  {element.expire_at && `${getDisplayDte(element.expire_at)}d`}</td>

                            <td style={{
                                padding: "5px",
                                fontWeight: "bold",
                                color: "black"
                            }} align="right">
                                {getPriceOption(element) != null && (
                                    <React.Fragment>
                                        {getPriceOption(element)}
                                        <span className="tooltip">
                                            <AccessTime fontSize="small" aria-hidden="true" />
                                            <span className="tooltiptext">Price delay 15min</span>
                                        </span>
                                    </React.Fragment>
                                )}
                            </td>
                            <td style={stylesLocal.cell} align="right">
                                {renderPl(getOrderOptionPl(element, props.option))}
                            </td>
                            <td style={stylesLocal.subcell} align="right">
                                {renderPlPercent(getOrderOptionPlPercent(element, props.option))}
                            </td>
                            <td style={stylesLocal.subcell} >

                            </td>
                            <td style={stylesLocal.cell} align="right">
                                {
                                    element.roll_accum && (
                                        <RollHistoryModal
                                            item={element}
                                            key={props.key}
                                            color={element.roll_accum < 0 ? "red" : "green"}
                                        />
                                    )
                                }
                            </td>
                            <td style={stylesLocal.subcell}>
                                <ActionBtnRight item={element} price={getPriceOption(element)} key={props.key} delete={() => { onClickDelete(element) }}/>
                                {/* <CloseModal
                                    item={element}
                                    key={props.key}
                                    price={getPriceOption(element)}
                                />
                                {" "}
                                <RollModal
                                    item={element}
                                    key={props.key}
                                    price={getPriceOption(element)}
                                />
                                {" "}
                                <span
                                    size="small"
                                    onClick={() => { onClickDelete(element) }}
                                >
                                    <Trash />

                                </span> */}

                            </td>
                        </tr>
                        );
                    })
                }
            </>
        </React.Fragment>
    )
}

SubRow.propTypes = {
    className: PropTypes.string
};

function mapStateToProps(reducer) {
    // console.log(reducer);
    return {

        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        option: reducer.event.option

    };
}
const mapDispatchToProps = dispatch => ({
    removeItem: (token, params) =>
        dispatch(actions.removeItem({ token, params })),
    updateReference: (token, params) =>
        dispatch(actions.updateReference({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubRow);

/**
 <GraphicModal item={subOrder} key={props.key} />
   <GraphicModal item={element} key={props.key} />
 */